import React from 'react';

import { SALES_PHONE_NUMBER_FORMATTED } from '~/common/utils/consts';

export default [
    {
        title: 'When can I start receiving calls on my new Grasshopper number(s)?',
        content: 'Most numbers are activated immediately upon checkout. Occasionally our toll free vanity numbers may take up to 24 hours to activate, but if that’s the case, we’ll let you know before checkout!'
    },
    {
        title: 'When do I pick my phone number(s)?',
        content: 'You pick your main phone number during the sign up process, and any additional numbers are chosen and managed by logging into your Grasshopper account, after checkout.'
    },
    {
        title: "Can I add extensions or phone numbers, on top of what's available in my plan?",
        content: 'Additional numbers, beyond what your plan includes, can be added to your account for a small fee. Extensions can be added by contacting our support team. Number and extensions are both managed by logging into your Grasshopper account, after checkout.'
    },
    {
        title: 'Do I have to sign a contract, and can I change my plan in the future?',
        content: 'Grasshopper service is provided on a monthly or annual basis. You can make changes to your plan at any time; upgrades take effect immediately, and downgrades take effect starting the following billing cycle. You are responsible for all usage charges incurred before a change takes effect.'
    },
    {
        title: 'Are international calls included in my unlimited minutes?',
        content: <span>International calls are not included at this time. International and off-shore calls are billed at per minute rates based on location, and {<a href="http://grasshopper.com/international-rates/" target="_blank">rates can be viewed here</a>}. To enable international calling on your account, please contact our support team.</span>
    },
    {
        title: 'Can I get a professional voice recording for my greetings?',
        content: 'Yes! Use our Voice Studio to get your greetings professionally recorded by one of our voice talents. Get up to 250 words for a one-time fee of $75.'
    },
    {
        title: 'Do you offer a discount for nonprofit or tax-exempt accounts?',
        content: `If you are a nonprofit company or believe your account is tax exempt, please open a ticket with our Customer Care team at ${SALES_PHONE_NUMBER_FORMATTED}. Please have an official proof documentation or a tax-exemption form ready when you make your request. You can also fax it directly to us at (888) 997-8688. Once we have your paperwork, our tax manager will review your request. All Grasshopper accounts are subject to federal, state, and local taxes`
    }
];
